import { HttpClient, HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable, map } from "rxjs";
import {
  ACCOUNTING_ENV,
} from "../../config/micros-env.tokens";
import { EnvMicroAccounting } from "../../config/env.micro.accounting";
import { WalletTopupRankingsSummaryResponse } from "../../../domain/models/accounting/wallet-topup-rankings.model";
import { WalletTopupRankingsPort } from "../../../app/ports/accounting/wallet-topup-rankings.port";
import { isWalletTopupRankingsSummaryResponse } from "../../validators/accounting/wallet-topup-rankings.validator";

@Injectable()
export class WalletTopupRankingsHttpAdapter implements WalletTopupRankingsPort {
  private static readonly SUMMARY_PATH = "/api/v1/wallet-topup-rankings/summary";

  constructor(
    private readonly http: HttpClient,
    @Inject(ACCOUNTING_ENV) private readonly env: EnvMicroAccounting,
  ) {}

  getSummary(companyId: number, month: string): Observable<WalletTopupRankingsSummaryResponse> {
    const baseUrl = `${this.env.host}${this.env.apiBasePath}`.replace(/\/$/, "");
    const params = new HttpParams()
      .set("idCompany", companyId)
      .set("month", month);

    return this.http.get<unknown>(`${baseUrl}${WalletTopupRankingsHttpAdapter.SUMMARY_PATH}`, { params }).pipe(
      map((response) => {
        if (!isWalletTopupRankingsSummaryResponse(response)) {
          throw new Error("La respuesta del ranking de recargas es inválida.");
        }
        return response;
      }),
    );
  }
}
